import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

function SessionTimeoutCountdown({
  promptBeforeIdle,
  idleTimer,
  getRemainingTime,
}) {
  const startCountdown = Math.ceil(promptBeforeIdle / 1000);
  const [seconds, setSeconds] = useState(startCountdown);

  useEffect(() => {
    const interval = setInterval(() => {
      const timeRemaining = Math.ceil(getRemainingTime() / 1000);
      setSeconds(timeRemaining);
    }, 1000);

    return () => {
      setSeconds(startCountdown);
      clearInterval(interval);
      idleTimer.reset();
    };
  }, [getRemainingTime, idleTimer, startCountdown]);
  return (
    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
      Your session will be terminated due to inactivite in {seconds} seconds.
    </Typography>
  );
}

SessionTimeoutCountdown.propTypes = {
  promptBeforeIdle: PropTypes.number,
  idleTimer: PropTypes.object,
  getRemainingTime: PropTypes.func,
};

export default SessionTimeoutCountdown;
